import { readRelationship } from './read-relationship';

export const coveredMemberFields = {
    relationship: {
        read: readRelationship,
    },
};
